module.exports = __webpack_public_path__ + "img/vertical-dark-sidebar.9b5eb0ae.jpg";